import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import { addNewMentor, getMentorById, updateMentor } from "../../../../redux/features/staff/staffService";
import { getAllOrganizations } from "../../../../redux/features/organization/organizationService";
import { getAllInterests } from "../../../../redux/features/interest/interestService";
import { getAllSkills } from "../../../../redux/features/skill/skillService";
import { showToast } from "../../../../components/ToastMsg";
import styles from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faAngleDown, faAngleUp, faXmark } from "@fortawesome/free-solid-svg-icons";

const EmplymentType = [
  { id: "1", name: "FULL_TIME" },
  { id: "2", name: "PART_TIME" },
];

const MentorDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { mentorDetails, isMentorLoading } = useSelector((state) => state.staff.mentorDetails);
  const { organizations } = useSelector((state) => state.organization.allOrganizations);
  const { interests } = useSelector((state) => state.interest.allInterests);
  const { skills } = useSelector((state) => state.skill.allSkills);
  const { isStaffMemberCreating } = useSelector((state) => state.staff.newStaffMember);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    create_mentor_experience_dtos: [],
    create_mentor_qualification_dtos: [],
    interests: [],
    skills: [],
  });
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [isExperienceToggled, setExperienceToggled] = useState(false);
  const [isQualificationToggled, setQualificationToggled] = useState(false);

  useEffect(() => {
    if (id) dispatch(getMentorById({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(getAllOrganizations({}));
    dispatch(getAllInterests({}));
    dispatch(getAllSkills({}));
  }, [dispatch]);

  useEffect(() => {
    if (mentorDetails) {
      setFormData({
        full_name: mentorDetails.full_name || "",
        email: mentorDetails.email || "",
        phone_number: mentorDetails.phone_number || "",
        create_mentor_experience_dtos: mentorDetails.mentor_experiences?.map(exp => ({
          organization_id: exp.organization || "",
          designation: exp.designation || "",
          description: exp.description || "",
          start_date: exp.start_date || "",
          employment_type: exp.employment_type || "",
          is_working: exp.is_working ? 1 : 0,
        })) || [],
        create_mentor_qualification_dtos: mentorDetails.mentor_qualifications?.map(q => ({
          school_or_university: q.school_or_university || "",
          degree_or_certificate: q.degree_or_certificate || "",
          field_of_study: q.field_of_study || "",
          description: q.description || "",
          start_date: q.start_date || "",
          end_date: q.end_date || "",
        })) || [],
        interests: mentorDetails.interests?.map(i => i.id) || [],
        skills: mentorDetails.skills?.map(s => s.id) || [],
      });
    }
  }, [mentorDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrorMessages(prev => ({ ...prev, [name]: "" }));
  };

  const handleArrayInputChange = (index, field, key, value) => {
    const updatedArray = [...formData[field]];
    updatedArray[index][key] = value;
    setFormData(prev => ({ ...prev, [field]: updatedArray }));
  };

  const addArrayItem = (field, emptyObj) => {
    setFormData(prev => ({ ...prev, [field]: [...prev[field], emptyObj] }));
  };

  const removeArrayItem = (field, index) => {
    const updatedArray = [...formData[field]];
    updatedArray.splice(index, 1);
    setFormData(prev => ({ ...prev, [field]: updatedArray }));
  };

  const handleToggleInterest = (id) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(id)
        ? prev.interests.filter(i => i !== id)
        : [...prev.interests, id]
    }));
  };

  const handleToggleSkill = (id) => {
    setFormData(prev => ({
      ...prev,
      skills: prev.skills.includes(id)
        ? prev.skills.filter(i => i !== id)
        : [...prev.skills, id]
    }));
  };

  const isValidMentor = () => {
    const errors = {};
    if (!formData.full_name.trim()) errors.full_name = "Name is required.";
    if (!formData.email) errors.email = "Email is required.";
    else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) errors.email = "Invalid email format.";
    if (!formData.phone_number) errors.phone_number = "Phone Number is required.";

    setErrorMessages(errors);
    return Object.keys(errors).length === 0;
  };

  const updateMentorDetails = async () => {
    if (!isValidMentor()) return;
    setDisabledBtn(true);
    try {
      const payload = { ...formData };
      //   const response = id
      //     ? await dispatch(updateMentor({ id, data: payload })).unwrap()
      //     : await dispatch(addNewMentor(payload)).unwrap();

      //   showToast("success", response.message);
    } catch (error) {
      showToast("error", error.message);
    } finally {
      setDisabledBtn(false);
    }
  };

  return (
    <div className="card-section">
      <div className="main-card">
        <h1 className={`form-title`}>Add New Mentor</h1>
        <div className={styles.formContainer}>
          <form className={styles.coordinatorForm} noValidate>
            <div className="form-input-row">
              <div className="form-input-col md-col">
                <div className="form-input-group">
                  <label className="form-label">
                    Full Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    className="form-input-default"
                  />
                  {errorMessages.full_name && (
                    <p className="text-danger">{errorMessages.full_name}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-input-row">
              <div className="form-input-col md-col">
                <div className="form-input-group">
                  <label className="form-label">
                    Email Address<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    className="form-input-default"
                  />
                  {errorMessages.email && (
                    <p className="text-danger">{errorMessages.email}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-input-row">
              <div className="form-input-col md-col">
                <div className="form-input-group">
                  <label className="form-label">
                    Phone Number<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="phone_number"
                    value={formData.phone_number}
                    onChange={handleInputChange}
                    placeholder="Enter Phone Number"
                    className="form-input-default"
                  />
                  {errorMessages.phone_number && (
                    <p className="text-danger">{errorMessages.phone_number}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-input-row">
              <div className="form-input-col md-col">
                <div className="form-input-group">
                  <label className="form-label">Interests</label>
                  <Dropdown
                    options={interests}
                    placeholder="Choose Interests"
                    value=""
                    onSelect={(selected) => handleToggleInterest(selected.id)}
                  />
                  <div className={styles.selectedTags}>
                    {formData.interests?.map((id) => {
                      const item = interests.find(i => i.id === id);
                      return (
                        <span key={id} className={styles.closetagRow}>
                          {item?.name}
                          <button
                            type="button"
                            onClick={() => handleRemoveInterest(id)}
                            className={styles.removeTag}
                          >
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </button>
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-input-row">
              <div className="form-input-col md-col">
                <div className="form-input-group">
                  <label className="form-label">Interests</label>
                  <Dropdown
                    options={skills}
                    placeholder="Choose Skills"
                    value=""
                    onSelect={(selected) => handleToggleSkill(selected.id)}
                  />
                  <div className={styles.selectedTags}>
                    {formData.skills?.map((id) => {
                      const item = skills.find(i => i.id === id);
                      return (
                        <span key={id} className={styles.closetagRow}>
                          {item?.name}
                          <button
                            type="button"
                            onClick={() => handleRemoveSkill(id)}
                            className={styles.removeTag}
                          >
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </button>
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.experienceSec}>
              <div className={styles.experienceHeader} onClick={() => setExperienceToggled(!isExperienceToggled)}>
                <h3>Experience {isExperienceToggled ? <FontAwesomeIcon icon={faAngleDown} /> : <FontAwesomeIcon icon={faAngleUp} />}</h3>
              </div>
              {isExperienceToggled &&
                <div className={styles.experienceExpandSec}>

                  <button
                    type="button"
                    className={`btn-add`}
                    onClick={() =>
                      addArrayItem("create_mentor_experience_dtos", {
                        organization_id: "",
                        designation: "",
                        description: "",
                        start_date: "",
                        employment_type: "",
                        is_working: 0,
                      })
                    }
                  >
                    + Add Experience
                  </button>
                  {formData.create_mentor_experience_dtos?.map((exp, index) => (
                    <div key={index} className={styles.experienceIndex}>
                      <h4>Experience {index + 1} <FontAwesomeIcon
                        type="button"
                        className={`text-danger ${styles.trashBtn}`}
                        onClick={() =>
                          removeArrayItem("create_mentor_experience_dtos", index)
                        }
                        icon={faTrashCan}
                      />
                      </h4>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Organization</label>
                            <Dropdown
                              options={organizations}
                              placeholder="Choose an Option"
                              value={organizations.find(o => o.id === exp.organization_id?.id)?.id || ""}
                              onSelect={(selected) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_experience_dtos",
                                  "organization_id",
                                  selected.id
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Designation</label>
                            <input
                              type="text"
                              value={exp.designation}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_experience_dtos",
                                  "designation",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                              placeholder="Enter the Designation"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Description</label>
                            <textarea
                              value={exp.description}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_experience_dtos",
                                  "description",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                              rows={3}
                              placeholder="Describe your role"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Start Date</label>
                            <input
                              type="date"
                              value={exp.start_date}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_experience_dtos",
                                  "start_date",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Employment Type</label>
                            <Dropdown
                              options={EmplymentType}
                              placeholder="Choose Employment Type"
                              value={EmplymentType.find(t => t.name === exp.employment_type)?.name || ""}
                              onSelect={(selected) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_experience_dtos",
                                  "employment_type",
                                  selected.name
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className={`form-input-group ${styles.labelRow}`}>
                            <label className="form-label">Currently Working?</label>
                            <input
                              type="checkbox"
                              checked={exp.is_working === 1}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_experience_dtos",
                                  "is_working",
                                  e.target.checked ? 1 : 0
                                )
                              }
                              className={styles.workCheckBox}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              }
            </div>
            <div className={styles.experienceSec}>
              <div className={styles.experienceHeader} onClick={() => setQualificationToggled(!isQualificationToggled)}>
                <h3>Qualification {isQualificationToggled ? <FontAwesomeIcon icon={faAngleDown} /> : <FontAwesomeIcon icon={faAngleUp} />}</h3>
              </div>
              {isQualificationToggled &&
                <div className={styles.experienceExpandSec}>
                  <button
                    type="button"
                    className={`btn-add`}
                    onClick={() =>
                      addArrayItem("create_mentor_qualification_dtos", {
                        school_or_university: "",
                        degree_or_certificate: "",
                        field_of_study: "",
                        description: "",
                        start_date: "",
                        end_date: ""
                      })
                    }
                  >
                    + Add Qualification
                  </button>
                  {formData.create_mentor_qualification_dtos?.map((q, index) => (
                    <div key={index} className={styles.experienceIndex}>
                      <h4>Qualification {index + 1} <FontAwesomeIcon
                        type="button"
                        className={`text-danger ${styles.trashBtn}`}
                        onClick={() =>
                          removeArrayItem("create_mentor_qualification_dtos", index)
                        }
                        icon={faTrashCan}
                      />
                      </h4>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">University / School</label>
                            <input
                              type="text"
                              value={q.school_or_university}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_qualification_dtos",
                                  "school_or_university",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                              placeholder="Enter University or School"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Degree / Certificate</label>
                            <input
                              type="text"
                              value={q.degree_or_certificate}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_qualification_dtos",
                                  "degree_or_certificate",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                              placeholder="Enter Degree or Certificate"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Field of Study</label>
                            <input
                              type="text"
                              value={q.field_of_study}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_qualification_dtos",
                                  "field_of_study",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                              placeholder="Enter Field of Study"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Description</label>
                            <textarea
                              value={q.description}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_qualification_dtos",
                                  "description",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                              rows={3}
                              placeholder="Add any details about this qualification"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">Start Date</label>
                            <input
                              type="date"
                              value={q.start_date}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_qualification_dtos",
                                  "start_date",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-input-row">
                        <div className="form-input-col md-col">
                          <div className="form-input-group">
                            <label className="form-label">End Date</label>
                            <input
                              type="date"
                              value={q.end_date}
                              onChange={(e) =>
                                handleArrayInputChange(
                                  index,
                                  "create_mentor_qualification_dtos",
                                  "end_date",
                                  e.target.value
                                )
                              }
                              className="form-input-default"
                            />
                          </div>

                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              }
            </div>
            <button
              className="btn-primary"
              type="button"
              disabled={disabledBtn}
              onClick={updateMentorDetails}
            >
              {isStaffMemberCreating ? <span>Loading...</span> : `Create`}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MentorDetails;